<div class="space-y-2">

  <div *ngIf="items.length === 0" class="text-sm text-gray-400 italic">
    No {{ findingType | lowercase }} options configured for this crop and field type.
  </div>

  <div
    *ngFor="let item of items"
    (click)="onItemClick(item)"
    class="flex items-center gap-4 p-3 rounded border transition-colors"
    style="cursor: pointer; background: white;"
    [style.background]="isSelected(item.id) ? 'color-mix(in srgb, var(--primary-dark) 8%, white)' : ''"
    [style.border-color]="isSelected(item.id) ? 'var(--primary-dark-variant)' : '#e5e7eb'">

    <!-- Reference photo — only shown when a URL is available -->
    <img
      *ngIf="item.referencePhotoDownloadUrl"
      [src]="item.referencePhotoDownloadUrl"
      class="w-12 h-12 object-cover rounded border border-gray-200 flex-shrink-0"
      alt="Reference" />

    <!-- Name + notes preview -->
    <div class="flex-1 min-w-0">
      <p class="text-sm font-medium text-gray-700">{{ item.name }}</p>
      <p *ngIf="isSelected(item.id) && selectedFindings.get(item.id)?.notes"
         class="text-xs text-gray-500 truncate mt-0.5">
        {{ selectedFindings.get(item.id)?.notes }}
      </p>
      <p *ngIf="isSelected(item.id) && (selectedFindings.get(item.id)?.photos?.length ?? 0) > 0"
         class="text-xs text-blue-500 mt-0.5">
        {{ selectedFindings.get(item.id)?.photos?.length }} photo(s) attached
      </p>
      <p *ngIf="isSelected(item.id) && (selectedFindings.get(item.id)?.voiceNotes?.length ?? 0) > 0"
         class="text-xs text-purple-500 mt-0.5">
        Voice note attached
      </p>
    </div>

    <!-- Remove button (selected items only) -->
    <div class="flex-shrink-0" *ngIf="isSelected(item.id) && !viewOnly">
      <button
        type="button"
        (click)="removeSelection(item.id, $event)"
        class="text-xs text-red-400 hover:text-red-600 px-2 py-0.5 rounded border border-red-200 hover:border-red-400">
        Remove
      </button>
    </div>

    <!-- Affordance: the whole row opens the detail modal — editable on a draft, read-only
         once finalised. Kept last so it sits in the same place on every row, whether or
         not Remove is present, and rendered in both modes so spacing does not shift. -->
    <mat-icon
      class="flex-shrink-0 text-gray-400"
      style="font-size:18px; width:18px; height:18px; line-height:18px;">
      {{ viewOnly ? 'visibility' : 'edit' }}
    </mat-icon>

  </div>

</div>
